var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFabStarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 62.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63,31.48A31.51,31.51,0,0,1,14.44,58a32.1,32.1,0,0,1-8.07-7.48A31.5,31.5,0,1,1,63,31.48Z",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.45,22.69l5-10.23A1.17,1.17,0,0,1,32,11.92a1.2,1.2,0,0,1,.54.53l5.06,10.2a1.18,1.18,0,0,0,.89.64L49.78,24.9a1.17,1.17,0,0,1,1,1.32,1.23,1.23,0,0,1-.34.67l-8.14,8a1.16,1.16,0,0,0-.33,1l2,11.23a1.17,1.17,0,0,1-1,1.35,1.19,1.19,0,0,1-.74-.12l-10.1-5.27a1.15,1.15,0,0,0-1.08,0L21,48.41a1.15,1.15,0,0,1-1.57-.48,1.13,1.13,0,0,1-.13-.74L21.17,36a1.16,1.16,0,0,0-.33-1L12.66,27a1.17,1.17,0,0,1,.64-2l11.27-1.66A1.19,1.19,0,0,0,25.45,22.69Z",
    style: {
      fill: "none",
      stroke: "#ff69b3",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabStarIcon);
export default __webpack_public_path__ + "static/media/fab-star-icon.5a6355e3398a983d0945bcb85f7bb006.svg";
export { ForwardRef as ReactComponent };